const priceContracts: {cakeAddress: string, busdAddress: string, lpAddress:string} = {
  cakeAddress: '0xf002d64DF02f1710EC99bF7084a55A80D4B1B1d8',
  busdAddress: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
  lpAddress: '0x36B8eE5c1f8FFB3b224736Ca9c989B1c531a613d' // needed to be changed after liquidity
}

export default priceContracts